/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import JS from '../JS';
import MemoryStorage from '../StorageHelper';

const Linking = {};
const AppState = {
    addEventListener(action, handler) {
        return;
    }
};

// if not in react native, just use local storage
const AsyncStorage = JS.browserOrNode().isBrowser ? new MemoryStorage().getStorage() : undefined;

export { Linking, AppState, AsyncStorage };
